export const questionActionTypes = {
    ADD_QUESTION: 'ADD_QUESTION',
    REMOVE_QUESTION: 'REMOVE_QUESTION',
    UPDATE_QUESTION: 'UPDATE_QUESTION',
    CLEAR_QUESTION: 'CLEAR_QUESTION',
  }
  